import { render } from "./SongTile.vue?vue&type=template&id=4966adc5&scoped=true"
import script from "./SongTile.vue?vue&type=script&lang=js"
export * from "./SongTile.vue?vue&type=script&lang=js"

import "./SongTile.vue?vue&type=style&index=0&id=4966adc5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4966adc5"]])

export default __exports__